// extracted by mini-css-extract-plugin
export default {"form-header":"FormHeader_form-header__f5TLr"};